import { makeObservable, observable, action, computed } from 'mobx';
import { SourceModelBase } from '../models';
import { CustomSourceData, CustomSourceOption } from '../types';
import { Filter } from '../../common/services/SessionService';
import { InstanceUtils } from '.';

export default class SourceProvider {
    loading: boolean = false;

    sourceData: CustomSourceData[] = [];

    constructor(private readonly source: SourceModelBase) {
        makeObservable(this, {
            loading: observable,
            sourceData: observable,
            setLoading: action,
            setSourceData: action,
            options: computed,
            values: computed
        });
    }

    setLoading(loading: boolean) {
        this.loading = loading;
    }

    setSourceData(sourceData: CustomSourceData[]) {
        this.sourceData = sourceData;
    }

    async getSourceOptions(ignoreCache?: boolean, filter?: Filter) {
        this.setSourceData(await this.source.getSources(ignoreCache, filter));
    }

    async getSourceOptionsByParent(parentValues: unknown) {
        if (!InstanceUtils.isLinkedSource(this.source)) {
            return;
        }

        this.setSourceData(await this.source.getSourcesByParent(parentValues));
    }

    get values() {
        return this.sourceData.map(data => data.value);
    }

    get options(): CustomSourceOption[] {
        return this.sourceData.map(data => ({
            label: data.text,
            value: data.value,
            title: data.text
        }));
    }

    get isLinkedSource() {
        return InstanceUtils.isLinkedSource(this.source);
    }
}
